import { initializeApp, FirebaseApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

// Pull the firebase config the global window object
const config = window.tenantFirebaseConfig;

let app: FirebaseApp | undefined;

// Dont set it up if its not there - important as some websites dont use it
if (config) {
    app = initializeApp(config);

    // Optional analytics if we need it
    if (config.measurementId) {
        try {
            getAnalytics(app);
        } catch {
            console.warn("Analytics not available");
        }
    }
} else {
    console.warn("No Firebase config for this tenant");
}

export default app;